<div id="container">
  <app-availability-selector></app-availability-selector>
  <app-availability-calendar></app-availability-calendar>
</div>
